import DOMPurify, { Config } from 'dompurify';

const sanitize = DOMPurify.sanitize;

export const sanitizeSVG = (svgString: string, options: Config): ReturnType<typeof sanitize> => {
  return sanitize(svgString, options);
};
